const isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  var isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

const initVideoInviewPlay = () => {
  document.querySelectorAll('.embed-wrapper.inview-play').forEach((embed) => {
    if(isScrolledIntoView(embed)) {
      if(embed.querySelector('deferred-media') && embed.querySelector('deferred-media').getAttribute('loaded') != true) {
        embed.querySelector('.deferred-media__poster').click();
      }
      embed.querySelector('video').play();
    }
    else {
      embed.querySelector('video').pause();
    }
  })
}

window.addEventListener('DOMContentLoaded', () => {
  initVideoInviewPlay();
})

window.addEventListener('scroll', () => {
  initVideoInviewPlay();
})